import React from 'react';

import { TranslatedLinkMessage } from './TranslatedLinkMessage';

const ResellerWarningText = () => (
  <p className="age-gate__reseller-warning-text">
    <TranslatedLinkMessage
      id={'RESELLER_WARNING_TEXT'}
      link={'RESELLER_WARNING_URL'}
      linkText={'RESELLER_WARNING_LINK_TEXT'}
    />
  </p>
);

export default ResellerWarningText;
